import type { LocalSettings } from "@app/config/LocalSettings";
import localSettings from "@app/config/LocalSettings";

class AnnouncementsSettings {
  settings: LocalSettings;

  // Per tab: set when an announcement CTA opened this tab, which turns announcements off in it.
  private readonly OFF_IN_TAB = "__MMC_ANNOUNCEMENTS_OFF_IN_TAB__";

  constructor(settings: LocalSettings) {
    this.settings = settings;
  }

  areAnnouncementsOffInTab = (): boolean => sessionStorage.getItem(this.OFF_IN_TAB) === "true";

  setAnnouncementsOffInTab = (off: boolean) => {
    if (off) {
      sessionStorage.setItem(this.OFF_IN_TAB, "true");
    } else {
      sessionStorage.removeItem(this.OFF_IN_TAB);
    }
  };
}

const announcementsSettings = new AnnouncementsSettings(localSettings);

export default announcementsSettings;
